module.exports = __webpack_public_path__ + "img/b1.f20f41ae.svg";